<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Auto Update</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Auto Update</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>

        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>

        <div *ngIf="!enableDisablePageLoader" class="auto-update-content-container">
          <div class="auto-update-card">
            <div class="section-title">Trigger Auto Update</div>
            <form [formGroup]="autoUpdateForm" (ngSubmit)="autoUpdate()" novalidate>
              <div class="form-container row">
                <!-- Device Serial No -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>Device Serial No.</mat-label>
                    <mat-select formControlName="serial_number">
                      <mat-option value="" disabled>Select Device Serial No.</mat-option>
                      <mat-option *ngFor="let dev of devices" [value]="dev.serial_number">{{ dev.serial_number }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="(autoUpdateFormValidation.serial_number.touched || submitted) && autoUpdateFormValidation.serial_number.hasError('required')">
                      <i>Device serial number is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- URL / Update File Name -->
                <div class="col-md-6 col-xs-12 mb-15">
                  <mat-form-field appearance="outline" class="w-100 density-compact">
                    <mat-label>URL</mat-label>
                    <input matInput formControlName="fileName" autocomplete="off" placeholder="Enter URL"/>
                    <mat-error *ngIf="(autoUpdateFormValidation.fileName.touched || submitted) && autoUpdateFormValidation.fileName.hasError('required')">
                      <i>URL is required.</i>
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Submit Button -->
                <div class="col-xs-12 text-right">
                  <div class="buttons-div reports_search_div d-inline-block">
                    <div class="transactions-button-container">
                      <button type="submit" class="transaction-submit-button" [disabled]="submitting">
                        <span class="icon"><img src="assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                        <span class="text">Submit</span>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

